import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TranslationRule } from '@helpers/types/models';
import { exist } from '@campaign-portal/namespace/common/id';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslationRulesService } from '../translation-rules.service';

@Component({
	selector: 'app-translation-rules-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TranslationRulesDialogComponent {

	private readonly destroyRef = inject(DestroyRef);
		
	constructor(
				@Inject(DIALOG_DATA) public readonly data: { rule: TranslationRule<exist> },
				public readonly service: TranslationRulesService,
				private readonly dialogRef: DialogRef<boolean>
	) {
	}

	confirm(): void {
		this.service.delete({ id: this.data.rule.ID })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp?.Success ) {
					this.dialogRef.close(true);
				}
			});
	}
		
	close(): void {
		this.dialogRef.close(false);
	}
}
